import React from 'react';

import './Divider.css'

const Divider = () => (
    <div className="divider"></div>
);

export default Divider;